export default "__VITE_ASSET__BFhJFdYD__"